import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../App.css';
import '../caseUpdates/caseUpdate.css';
import Dashheader from '../Dash-header/Dashheader';
import Sidebar from '../dashboard/Sidebar';
import Orangerolling from '../../images/orange-roll.gif';
import { END_URL, IMG_URL } from "../../config.js";

import UserFooter from '../footer/UserFooter.jsx';

function CaseUpdate() {
    const [caseUpdates, setCaseUpdates] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedCase, setSelectedCase] = useState(null);
    const [viewedCases, setViewedCases] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [dynamicContent, setDynamicContent] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [whatsNextContent, setWhatsNextContent] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [expanded1, setExpanded] = useState(false);

    const [isLoading, setisLoading] = useState(true);

    // Fetch Case Updates
    useEffect(() => {
        const fetchCaseUpdates = async () => {
            try {

                setisLoading(true);

                const response = await axios.get(`${END_URL}caseupdate`);
                if (response.data.status) {
                    const sortedUpdates = response.data.data.sort(
                        (a, b) => new Date(b.date) - new Date(a.date)
                    );
                    setCaseUpdates(sortedUpdates);
                    if (sortedUpdates.length > 0) setSelectedCase(sortedUpdates[0]);

                    setisLoading(false);
                }
            } catch (err) {
                setError(err.message || 'Something went wrong');
            } finally {
                setLoading(true);
            }
        };
        fetchCaseUpdates();
    }, []);

    useEffect(() => {
        const fetchWhatsNext = async () => {
            try {
                const response = await axios.get(`${END_URL}whatsnext`);
                if (response.data.status && response.data.data.length > 0) {
                    setWhatsNextContent(response.data.data[0].upcomingevent);
                }
            } catch (error) {
                console.error("Failed to fetch what's next content:", error);
            }
        };
        fetchWhatsNext();
    }, []);

    // Fetch Dynamic Content
    useEffect(() => {
        const fetchDynamicContent = async () => {
            try {
                const response = await axios.get(`${END_URL}dynamic-page`);
                setDynamicContent(response.data.data);
            } catch (error) {
                console.error('Failed to fetch dynamic content:', error);
            }
        };
        fetchDynamicContent();
    }, []);

    const isNew = (caseDate, days = 7) => {
        const caseDateObj = new Date(caseDate);
        const now = new Date();
        const diffTime = now - caseDateObj;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays <= days;
    };

    const handleReadMore = (caseItem) => {
        setSelectedCase(caseItem);
        if (!viewedCases.includes(caseItem.id)) {
            setViewedCases((prev) => [...prev, caseItem.id]);
        }
    };

    const filteredCaseUpdates = caseUpdates.filter((caseUpdate) => {
        const matchesCategory = selectedCategory
            ? caseUpdate.category?.name === selectedCategory
            : true;

        const searchTerms = searchQuery.toLowerCase().split(" ");
        const searchableText = `${caseUpdate.title} ${caseUpdate.category?.name} ${new Date(caseUpdate.date).toLocaleDateString()}`.toLowerCase();
        const matchesSearch = searchTerms.every(term => searchableText.includes(term));

        return matchesCategory && matchesSearch;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCaseUpdates.slice(indexOfFirstItem, indexOfLastItem);

    const nextPage = () => {
        if (currentPage < Math.ceil(filteredCaseUpdates.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const categories = [...new Set(caseUpdates.map(cu => cu.category?.name).filter(Boolean))];

    return (
        <div className="dashboard-container full-width">
            <Dashheader />
            <div className="container">
                <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
                    <div className="col-12 col-sm-12 col-md-3 col-lg-3">
                        <div className="dashboard-side-div">
                            <Sidebar />
                            <a href="#" className="expand-btn" onClick={(e) => {
                                e.preventDefault();
                                setExpanded(!expanded1);
                            }}><span></span></a>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                        <main className="content">
                            <div className="form-container">
                                <div className="dashbord-first">
                                    <div dangerouslySetInnerHTML={{ __html: dynamicContent?.caseupdate1 }} />
                                </div>

                                <div className="case-row1 row">
                                    {/* Left side: selected case */}
                                    <div className="col-md-8">

                                        {isLoading ? (

                                            <div className="case-box skeleton">
                                                <div className="skeleton-title"></div>
                                                <div className="skeleton-meta"></div>
                                                <div className="skeleton-content"></div>
                                                <div className="skeleton-content short"></div>
                                                <div className="skeleton-link"></div>
                                            </div>

                                        ) : (

                                            <div className="case-list">
                                                {!selectedCase ? (

                                                    <p>Select a case from the list to view details.</p>

                                                ) : (
                                                    <div key={selectedCase.id} className="case-box">
                                                        <h3>{selectedCase.title}</h3>
                                                        <p className="no-uppercase" style={{ borderBottom: '1px solid #e7eceb', fontSize: '14px', color: '#5f6b68', margin: '0', paddingBottom: '14px' }}>

                                                            {selectedCase?.category?.image && (
                                                                <img src={`${IMG_URL}/public/${selectedCase?.category?.image}`} />
                                                            )}

                                                            <strong> {selectedCase.category?.name} | Date: </strong> {selectedCase?.fomated_date}
                                                        </p>
                                                        <div className="case-content">

                                                            <p dangerouslySetInnerHTML={{ __html: selectedCase.summary }} />

                                                            {selectedCase.casepdf && (
                                                                <>
                                                                    <h4>Related Documents</h4>
                                                                    <p>
                                                                        <a href={`${IMG_URL}/public/${selectedCase.casepdf}`} target="_blank" rel="noopener noreferrer">
                                                                            {selectedCase.casepdfname}
                                                                        </a>
                                                                    </p>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                        )}


                                    </div>

                                    {/* Right side: filters and list */}
                                    <div className="col-md-4">
                                        <div className="case-filters">
                                            <h4>Latest Updates</h4>
                                            <div className="case-search">
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder="Search"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />
                                            </div>

                                            <div className="category-filter">
                                                <select
                                                    id="categoryFilter"
                                                    className="form-control"
                                                    value={selectedCategory}
                                                    onChange={(e) => {
                                                        setSelectedCategory(e.target.value);
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value="">All Categories</option>
                                                    {categories.map((cat) => (
                                                        <option key={cat} value={cat}>{cat}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {Loading ? (

                                            <div className="case-latelist">
                                                {currentItems.length > 0 ? (
                                                    currentItems.map((caseUpdate) => (
                                                        <div
                                                            key={caseUpdate.id}
                                                            className={`case-latbox ${selectedCase?.id === caseUpdate.id ? 'active' : ''}`}
                                                            onClick={() => handleReadMore(caseUpdate)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <h5>{caseUpdate.title}</h5>
                                                            <p>{caseUpdate?.fomated_date} - {caseUpdate.category?.name}</p>
                                                            {isNew(caseUpdate.date) && !viewedCases.includes(caseUpdate.id) && (
                                                                <span className="new-tag">New</span>
                                                            )}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className='case-latbox'>
                                                        <h3>No New Updates Found</h3>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <>
                                                {[1, 2, 3, 4].map((n) => (
                                                    <div key={n} className="case-latbox skeleton">
                                                        <div className="skeleton-title"></div>
                                                        <div className="skeleton-meta"></div>
                                                    </div>
                                                ))}
                                            </>
                                        )}

                                        {filteredCaseUpdates.length > 0 && (
                                            <div className="pagination-buttons">
                                                <button onClick={prevPage} disabled={currentPage === 1}>Previous</button>
                                                <button onClick={nextPage} disabled={currentPage === Math.ceil(filteredCaseUpdates.length / itemsPerPage)}>Next</button>
                                            </div>
                                        )}

                                        <div className="whats-next" dangerouslySetInnerHTML={{ __html: whatsNextContent || '' }} />
                                    </div>
                                </div>
                            </div>
                            <UserFooter />
                        </main>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CaseUpdate;
